const ErrorAlert = ({ error }) => {
  console.log(error);
  return null;
};

export default ErrorAlert;